/**
 * validator
 *
 * @author Shigq
 * @date 2021/5/18 15:49
 */
import { useI18n } from '@/plugins/i18n'
import { checkEmail } from '@/api/modules/user'

export default function() {
  // todo - declare
  const { t } = useI18n()

  // todo - validate
  const scopedValidators = {
    async validateEmailUniqueness(rule, value, callback) {
      try {
        const res = await checkEmail({ email: value })
        if (res.emailExists) {
          callback(new Error(t('common.validate.emailUniqueness')))
        } else {
          callback()
        }
      } catch (e) {
        callback()
      }
    },
    async validateEmailRegister(rule, value, callback) {
      try {
        const res = await checkEmail({ email: value })
        if (!res.emailExists) {
          callback(new Error('该邮箱号未注册!'))
        } else {
          callback()
        }
      } catch (e) {
        callback()
      }
    },
    validateCharacterSet(rule, value, callback) {
      const regExp = /^[a-zA-Z0-9-/;().,'+ ]+$/
      if (value && !regExp.test(value)) {
        callback(new Error(t('common.validate.characterSet')))
      } else {
        callback()
      }
    },
    validatePasswordCurrentProject(rule, value, callback) {
      const regExp = /^(?=\S*\d)(?=\S*[a-zA-Z])(?=\S*[!@#])[0-9A-Za-z!@#]{8,12}$/
      if (!regExp.test(value)) {
        callback(new Error(t('common.validate.passwordRule')))
      } else {
        callback()
      }
    },
  }

  return {
    ...scopedValidators
  }
}
